import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { ThemeProvider } from "@mui/material";
import { theme } from "./theme/theme";
import { RouterProvider } from "react-router-dom";
import router from "./router";
import "./helpers/translations";
import { FeedContextProvider } from "./helpers/feed/FeedContextProvider";
import { I18nextProvider } from "react-i18next";
import i18n from "./helpers/translations";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const App = () => {
  return (
    <>
      <I18nextProvider i18n={i18n}>
        <FeedContextProvider>
          <ThemeProvider theme={theme}>
            <RouterProvider router={router} />
          </ThemeProvider>
        </FeedContextProvider>
      </I18nextProvider>
      {/* )} */}
    </>
  );
};

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
